// extracted by mini-css-extract-plugin
export default {"form":"UsedStampsPrometModal_form__bDKq1","opsegRow":"UsedStampsPrometModal_opsegRow__3sVjO","opsegDelete":"UsedStampsPrometModal_opsegDelete__ETEHL"};